import type { ListBuilderList } from '../../../types';
import { createStandardOrderColumns } from '../columns';
import {
	CART_REQUIRED_FIELDS,
	ORDER_MOBILE_CARD_CONFIG,
	SALES_REP_FILTER_RULES,
} from '../shared';

/**
 * Today's Carts list configuration
 * Draft orders (carts) created today in CRM
 */
export const todaysCartsList: ListBuilderList = {
	id: 'todays-carts',
	cacheTTL: 600000,
	name: "Today's Carts",
	type: 'default',
	active: true,
	sortOrder: 3,
	requiredFeature: 'order-entry',
	columns: createStandardOrderColumns(),
	mobileCardConfig: ORDER_MOBILE_CARD_CONFIG,
	description: 'Draft orders (carts) created today in CRM',
	defaultSortId: 'column-dates-desc',
	requiredFields: CART_REQUIRED_FIELDS,
	filterRules: {
		...SALES_REP_FILTER_RULES,
		orderModifiedDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
		orderStatus: {
			defaultValue: [
				{
					id: '1',
					label: 'Unsubmitted',
				},
			],
		},
		orderOrigin: {
			defaultValue: [
				{
					id: '1',
					label: 'CRM',
				},
			],
		},
	},
};
